export default __webpack_public_path__ + "54fc19b78e25bb19f1dbbd4a8f79f513.png";